import { z } from 'zod'

const YES = 'Yes'
const NO = 'No'

export const YesNoOptions = [YES, NO] as const

const YesNoType = z.preprocess((val) => {
  if (typeof val === 'boolean') return val ? YES : NO
  return val
}, z.stringbool())

/**
 *
 * Cloning is required when used with the field registry because the field registry
 * will see multiple registration of the same field and the last one will win
 * type.
 *
 * @returns A clone of the YesNoType that is safe to use with the field registry
 */
export const yesNoType = () => YesNoType.clone()
